import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

function Report({open, handleReportClose}) {

  return <>
    <Dialog onClose={() => handleReportClose(false)} open={open} fullWidth={true}>
      <DialogTitle>Report</DialogTitle>
      <Box sx={{m: 2}}>
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">Reason</FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
          >
            <FormControlLabel value="female" control={<Radio/>} label="Abuse"/>
            <FormControlLabel value="male" control={<Radio/>} label="Sexual content"/>
            <FormControlLabel value="other" control={<Radio/>} label="Other"/>
            <TextField
              id="outlined-multiline-flexible"
              label="Comments(Optional)"
              multiline
              maxRows={5}
              minRows={2}
            />
          </RadioGroup>
          <hr/>
          <Stack direction={'row'} spacing={2}>
            <Button variant="outlined" onClick={() => handleReportClose(false)}>Close</Button>
            <Button variant="contained" onClick={() => handleReportClose(false)}>Submit</Button>

          </Stack>

        </FormControl>
      </Box>
    </Dialog>
  </>
}

export default Report
